const elementIsInView = (selector, callback) => {
  const observer = new MutationObserver((mutations) => {
    if (document.querySelector(selector)) {
      observer.disconnect();
      callback();
    }
  });

  observer.observe(document.body, {
    //Attributes
    childList: true,
    subtree: true,
  });
};

elementIsInView('.sizing-calculator-container', () => {
  const target = document.querySelector('.product-variant[data-type="size"] .product-variant__name');
  const calculator = document.querySelector('.sizing-calculator-container');

  if (target && calculator) {
    target.append(calculator);
  }
});

const createSliders = () => {
  const sliders = document.querySelectorAll('.io-0002-slide')
  sliders.forEach((slide) => initSlide(slide));
}

const initSlide = (slide) => {
  const slider = document.getElementById(slide.id);
  const container = slider.querySelector('.io-0002-slide-items');
  const btnPrev = slider.querySelector('.io-0002-slide-btn.prev');
  const btnNext = slider.querySelector('.io-0002-slide-btn.next');

  const scrollAmount = 88;

  btnPrev.addEventListener('click', () => {
    container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  });

  btnNext.addEventListener('click', () => {
    container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  });
}


document.addEventListener('DOMContentLoaded', (event) => {
  createSliders();
});
